import { publicFetch } from "./client"
import type { Station, StationDetails, VehiclePosition } from "./types"

interface RawStop {
  id?: string
  namespaced_id?: string
  name: string
  lat: number
  lon: number
}

interface RawRoute {
  namespaced_id?: string
  id?: string
  short_name?: string
  shortName?: string
  long_name?: string
  longName?: string
}

export async function getStations(cityId = "accra"): Promise<Station[]> {
  try {
    const data = await publicFetch<{ stops?: RawStop[] }>(
      `/cities/base-data?city_id=${cityId}`,
    )
    if (data.stops && Array.isArray(data.stops)) {
      return data.stops.map((stop) => ({
        id: stop.id || stop.namespaced_id || "",
        name: stop.name,
        lat: stop.lat,
        lon: stop.lon,
      }))
    }
    return []
  } catch (error) {
    console.error("Fetch stations error:", error)
    return []
  }
}

export async function getStationDetails(stopId: string): Promise<StationDetails | null> {
  try {
    const data = await publicFetch<{ stop?: RawStop & { namespaced_id?: string }; routes?: RawRoute[] }>(
      `/stops/${encodeURIComponent(stopId)}`,
    )
    return {
      stop: {
        id: data.stop?.namespaced_id || data.stop?.id || stopId,
        name: data.stop?.name || "Unknown Station",
        lat: data.stop?.lat || 0,
        lon: data.stop?.lon || 0,
      },
      routes: (data.routes || []).map((route) => ({
        id: route.namespaced_id || route.id || "",
        shortName: route.short_name || route.shortName || "",
        longName: route.long_name || route.longName || "",
      })),
    }
  } catch (error) {
    console.error("Fetch station details error:", error)
    return null
  }
}

export async function getStopVehicles(stopId: string): Promise<VehiclePosition[]> {
  try {
    const data = await publicFetch<{ vehicles?: VehiclePosition[] }>(
      `/stops/${encodeURIComponent(stopId)}/vehicles`,
    )
    return data.vehicles || []
  } catch (error) {
    console.error("Fetch stop vehicles error:", error)
    return []
  }
}
